import {Box, Typography} from '@customink/pigment-react';
import PropTypes from 'prop-types';
import React from 'react';
import useProductCardPrice from '../../hooks/useProductCardPrice';

export default function ProductCardUnbundledPriceDetails({
  decorationMethod,
  defaultUnitPrices,
  quantity
}) {
  const {localizedPrice} = useProductCardPrice({
    decorationMethod,
    defaultUnitPrices,
    quantity,
    showUnbundledPrice: true
  });

  if (!localizedPrice) {
    return null;
  }

  return (
    <Box
      display="flex"
      data-testid="product-price-details"
      flexDirection="column"
      alignItems="flex-start"
      gap="0.125rem">
      <Typography fontSize="0.8125rem" lineHeight={1.25}>
        From{' '}
        <Box component="span" fontWeight={700}>
          {localizedPrice}
        </Box>{' '}
        ea. for {quantity} items
      </Typography>
    </Box>
  );
}

ProductCardUnbundledPriceDetails.propTypes = {
  decorationMethod: PropTypes.string,
  defaultUnitPrices: PropTypes.arrayOf(PropTypes.object).isRequired,
  quantity: PropTypes.number.isRequired
};
